// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".tag-select_09be .none_3536 span {\n  font-style: italic;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/SelectTags/TagSelect.scss","TagSelect.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;ACAR","file":"TagSelect.scss","sourcesContent":[".tag-select {\n    .none span {\n        font-style: italic;\n    }\n}\n",".tag-select .none span {\n  font-style: italic;\n}"]}]);
// Exports
exports.locals = {
	"tag-select": "tag-select_09be",
	"none": "none_3536"
};
module.exports = exports;
